import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import './Lucky7C.css';
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function Lucky7C() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "lucky7eu2";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
      gameName={"Lucky 7 - C"}
    >
      {/* <div className="center-main-container casino-page"> */}
      {/* <div className="center-container"> */}
      {/* <div className="casino-page-container lucky7a"> */}
      {/* <div className="casino-header">
            <span className="casino-name">
              Lucky 7 - C
              <a className="ms-1">
                <small>Rules</small>
              </a>
            </span>
            <span className="casino-rid d-none d-xl-inline-block">
              <small>
                Round ID: <span>134250425212949</span>
              </small>
            </span>
          </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none">
            <ul className="nav nav-tabs menu-tabs">
              <li className="nav-item">
                <div className="nav-link active">Game</div>
              </li>
              <li className="nav-item">
                <div className="nav-link">Placed Bet (0)</div>
              </li>
            </ul>
            <div className="pe-2">
              <span className="casino-rid">
                Round ID: <span>134250425212949</span>
              </span>
            </div>
          </div> */}
      {/* <div className=""> */}
      {/* <div className="casino-video"> */}
      {/* <div className="video-box-container"> */}
      {/* <div className="casino-video-box"> */}
        {/* <iframe src="/mediaplayer/lucky7eu2/b165b5a1-21e9-4511-a705-bb0facc39b76?ip=122.160.119.41" /> */}
      {/* </div> */}
      {/* </div> */}
      {/* <div className="casino-video-cards">
                <div>
                  <div className="flip-card-container">
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
      {/* <div className="clock flip-clock-wrapper">
            <ul className="flip play">
              <li className="flip-clock-before">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">2</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">2</div>
                  </div>
                </a>
              </li>
              <li className="flip-clock-active">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">1</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">1</div>
                  </div>
                </a>
              </li>
            </ul>
            <ul className="flip play">
              <li className="flip-clock-before">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">7</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">7</div>
                  </div>
                </a>
              </li>
              <li className="flip-clock-active">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">6</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">6</div>
                  </div>
                </a>
              </li>
            </ul>
          </div> */}
      {/* </div> */}
      <div className="casino-detail lucky7c">
        <div className="casino-table">
         <div
  className="casino-table-full-box"
  style={{
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    width: "100%",
    boxSizing: "border-box",
    flexWrap: "wrap", // allows wrapping on very small screens
  }}
>
  {/* Low Card (Left) */}
  <div
    className="lucky7low"
    style={{
      flex: "1",
      minWidth: "100px",
      textAlign: "center",
      marginRight: "10px",
    }}
  >
    <div style={{ fontSize: "16px", marginBottom: "5px" }}>
      {getOddForEntity("Low Card", casinoData, true)}
    </div>
    <div
      className={`casino-odds-box back casino-odds-box-theme ${
        casinoData?.data?.response?.autoTime < 5 ? "suspended-box" : ""
      }`}
      onClick={() => setBet("Low Card", casinoData, dispatch, "back")}
      style={{
        backgroundColor: "#eee",
        padding: "10px",
        borderRadius: "6px",
        cursor: "pointer",
        fontWeight: "bold",
        marginBottom: "5px",
      }}
    >
      <span className="casino-odds">Low Card</span>
    </div>
    <div style={{ fontSize: "14px", color: "#444" }}>
      {getCasinoPlExposureByRunner(casinoPlData, "Low Card")}
    </div>
  </div>

  {/* Card Image (Center) */}
  <div
    className="lucky7"
    style={{
      flex: "0 0 auto",
      textAlign: "center",
      margin: "0 10px",
    }}
  >
    <img
      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/7.png"
      alt="Card 7"
      style={{
        width: "60px",
        height: "auto",
      }}
    />
  </div>

  {/* High Card (Right) */}
  <div
    className="lucky7high"
    style={{
      flex: "1",
      minWidth: "100px",
      textAlign: "center",
      marginLeft: "10px",
    }}
  >
    <div style={{ fontSize: "16px", marginBottom: "5px" }}>
      {getOddForEntity("High Card", casinoData, true)}
    </div>
    <div
      className={`casino-odds-box back casino-odds-box-theme ${
        casinoData?.data?.response?.autoTime < 5 ? "suspended-box" : ""
      }`}
      onClick={() => setBet("High Card", casinoData, dispatch, "back")}
      style={{
        backgroundColor: "#eee",
        padding: "10px",
        borderRadius: "6px",
        cursor: "pointer",
        fontWeight: "bold",
        marginBottom: "5px",
      }}
    >
      <span className="casino-odds">High Card</span>
    </div>
    <div style={{ fontSize: "14px", color: "#444" }}>
      {getCasinoPlExposureByRunner(casinoPlData, "High Card")}
    </div>
  </div>
</div>

          <div className="casino-table-box mt-3">
            <div className="casino-table-left-box">
              <div className=" lucky7odds">
                <div className="casino-odds text-center">
                  {getOddForEntity("Even", casinoData, true)}
                </div>
                {/* <div className="casino-odds-box back casino-odds-box-theme"> */}
                <div
                  className={`casino-odds-box back  casino-odds-box-theme ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() => setBet("Even", casinoData, dispatch, "back")}
                >
                  <span className="casino-odds">Even</span>
                </div>
                {/* <div className="casino-nation-book text-center" /> */}
                <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Even")}
              </div>
              </div>
              <div className=" lucky7odds">
                <div className="casino-odds text-center">
                  {getOddForEntity("Odd", casinoData, true)}
                </div>
                {/* <div className="casino-odds-box back casino-odds-box-theme"> */}
                <div
                  className={`casino-odds-box back  casino-odds-box-theme ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() => setBet("Odd", casinoData, dispatch, "back")}
                >
                  <span className="casino-odds">Odd</span>
                </div>
                {/* <div className="casino-nation-book text-center" /> */}
                <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Odd")}
              </div>
                
              </div>
            </div>
            <div className="casino-table-right-box">
              <div className=" lucky7odds">
                <div className="casino-odds text-center">
                  {getOddForEntity("Red", casinoData, true)}
                </div>
                {/* <div className="casino-odds-box back casino-odds-box-theme"> */}
                <div
                  className={`casino-odds-box back  casino-odds-box-theme ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() => setBet("Red", casinoData, dispatch, "back")}
                >
                  <span className="casino-odds">
                    <span className="card-icon ms-1">
                      <span className="card-red ">{"{"}</span>
                    </span>
                    <span className="card-icon ms-1">
                      <span className="card-red ">[</span>
                    </span>
                  </span>
                </div>
                {/* <div className="casino-nation-book text-center" /> */}
                <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Red")}
              </div>
              </div>
              <div className=" lucky7odds">
                <div className="casino-odds text-center">
                  {getOddForEntity("Black", casinoData, true)}
                </div>
                {/* <div className="casino-odds-box back casino-odds-box-theme"> */}
                <div
                  className={`casino-odds-box back  casino-odds-box-theme ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() => setBet("Black", casinoData, dispatch, "back")}
                >
                  <span className="casino-odds">
                    <span className="card-icon ms-1">
                      <span className="card-black ">{"}"}</span>
                    </span>
                    <span className="card-icon ms-1">
                      <span className="card-black ">]</span>
                    </span>
                  </span>
                </div>
                {/* <div className="casino-nation-book text-center" /> */}
                <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Black")}
              </div>
              </div>
            </div>
          </div>
          <div className="casino-table-box mt-3">
            <div className="lucky7cards">
              <div className="casino-odds w-100 text-center">
                {" "}
                <b>{getOddForEntity("Line 1", casinoData, true)}</b>
              </div>
              <div className="card-odd-box-container">
                <div className="card-odd-box">
                  <div
                    className={`${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Line 1", casinoData, dispatch, "back")
                    }
                  >
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/A.png" />
                  </div>
                </div>
                <div className="card-odd-box">
                  <div
                    className={`${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                  >
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/2.png" />
                  </div>
                </div>
                <div className="card-odd-box">
                  <div
                    className={`${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                  >
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/3.png" />
                  </div>
                </div>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Line 1")}
              </div>
            </div>
            <div className="lucky7cards">
              <div className="casino-odds w-100 text-center">
                {" "}
                <b>{getOddForEntity("Line 2", casinoData, true)}</b>
              </div>
              <div className="card-odd-box-container">
                <div className="card-odd-box">
                  <div
                    className={`${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Line 2", casinoData, dispatch, "back")
                    }
                  >
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/4.png" />
                  </div>
                </div>
                <div className="card-odd-box">
                  <div
                    className={`${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                  >
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/5.png" />
                  </div>
                </div>
                <div className="card-odd-box">
                  <div
                    className={`${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                  >
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/6.png" />
                  </div>
                </div>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Line 2")}
              </div>
            </div>
            <div className="lucky7cards">
              <div className="casino-odds w-100 text-center">
                {" "}
                <b>{getOddForEntity("Line 3", casinoData, true)}</b>
              </div>
              <div className="card-odd-box-container">
                <div className="card-odd-box">
                  <div
                    className={`${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Line 3", casinoData, dispatch, "back")
                    }
                  >
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/8.png" />
                  </div>
                </div>
                <div className="card-odd-box">
                  <div
                    className={`${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                  >
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/9.png" />
                  </div>
                </div>
                <div className="card-odd-box">
                  <div
                    className={`${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                  >
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/10.png" />
                  </div>
                </div>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Line 3")}
              </div>
            </div>
            <div className="lucky7cards">
              <div className="casino-odds w-100 text-center">
                {" "}
                <b>{getOddForEntity("Line 4", casinoData, true)}</b>
              </div>
              <div className="card-odd-box-container">
                <div className="card-odd-box">
                  <div
                    className={`${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Line 4", casinoData, dispatch, "back")
                    }
                  >
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/J.png" />
                  </div>
                </div>
                <div className="card-odd-box">
                  <div
                    className={`${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                  >
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/Q.png" />
                  </div>
                </div>
                <div className="card-odd-box">
                  <div
                    className={`${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                  >
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/K.png" />
                  </div>
                </div>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Line 4")}
              </div>
            </div>
          </div>
          <div className="casino-table-full-box lucky7acards mt-3">
            <div className="casino-odds w-100 text-center">
              {" "}
              {/* <b>{getOddForEntity("Card A", casinoData, true)}</b>{" "} */}
              {getOddForEntity("Card 1", casinoData)}
            </div>
            <div className="card-odd-box">
              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 1", casinoData, dispatch, "back")}
              >
                <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/A.png" />
              </div>
              {/* <div className="casino-nation-book" /> */}
                <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 1")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 2", casinoData, dispatch, "back")}
              >
                <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/2.png" />
              </div>
              {/* <div className="casino-nation-book" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 2")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 3", casinoData, dispatch, "back")}
              >
                <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/3.png" />
              </div>
              {/* <div className="casino-nation-book" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 3")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 4", casinoData, dispatch, "back")}
              >
                <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/4.png" />
              </div>
              {/* <div className="casino-nation-book" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 4")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 5", casinoData, dispatch, "back")}
              >
                <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/5.png" />
              </div>
              {/* <div className="casino-nation-book" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 5")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 6", casinoData, dispatch, "back")}
              >
                <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/6.png" />
              </div>
              {/* <div className="casino-nation-book" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 6")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 7", casinoData, dispatch, "back")}
              >
                <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/7.png" />
              </div>
              {/* <div className="casino-nation-book" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 7")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 8", casinoData, dispatch, "back")}
              >
                <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/8.png" />
              </div>
              {/* <div className="casino-nation-book" /> */}
                 <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 8")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 9", casinoData, dispatch, "back")}
              >
                <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/9.png" />
              </div>
              {/* <div className="casino-nation-book" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 9")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 10", casinoData, dispatch, "back")}
              >
                <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/10.png" />
              </div>
              {/* <div className="casino-nation-book" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 10")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card J", casinoData, dispatch, "back")}
              >
                <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/J.png" />
              </div>
              {/* <div className="casino-nation-book" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Card J")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card Q", casinoData, dispatch, "back")}
              >
                <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/Q.png" />
              </div>
              {/* <div className="casino-nation-book" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Card Q")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card K", casinoData, dispatch, "back")}
              >
                <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/K.png" />
              </div>
              {/* <div className="casino-nation-book" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Card K")}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}

      {/* </div> */}
      {/* </div> */}

      {/* </div> */}
    </CasinoPage>
  );
}
